// src/features/organisation/hooks/useRoles.ts
import { useState, useEffect } from 'react';
import { rolesApi } from '../services/organisationApi';
import { Role } from '../../../types/organisation/roles.types';

export const useRoles = () => {
  const [roles, setRoles] = useState<Role[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  const fetchRoles = async () => {
    try {
      setLoading(true);
      const data = await rolesApi.getAll();
      setRoles(data || []);
      setError(null);
    } catch (err) {
      console.error('useRoles - error:', err);
      setError(err as Error);
      setRoles([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRoles();
  }, []);

  return { roles, loading, error, refresh: fetchRoles };
};